import React, { Suspense }              from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {render, unmountComponentAtNode} from 'react-dom';

import PjaxWrapper   from '../../utils/PjaxWrapper';
import ProfileRoutes from '../../components/ActorProfile/ProfileRoutes.js';

import ActorProfile from '../../components/ActorProfile/ActorProfile.jsx';
import LogoLoader 	from '../../components/Loader/LogoLoader.js';

/**
 * @param hook
 */
function run(
	hook,
) {
	const profileContainer = document.getElementById(hook);

	render(
		<BrowserRouter>
			<Suspense fallback={<LogoLoader pulse={true} isRelative={true}/>}>
				<Routes>
					<Route 
						path 	= {ProfileRoutes.getPathByName(ProfileRoutes.ACTOR_PROFILE)}
						element = {<ActorProfile />}
					/>
				</Routes>
			</Suspense>
		</BrowserRouter>,
		profileContainer
	);
	PjaxWrapper.addUnloadFunc(() => {
		unmountComponentAtNode(profileContainer);
		window.history.replaceState({pjax:true, url: document.location.href}, document.title, window.location.href);
	});
}

export {run};